import React from "react";
import FilesStatus from "../filesStatus";
import TableCmp from "../TableCmp";
import { useQuery, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { WORK_FLOW_TYPE } from "../../../config/cacheKey";
import { GetCartablesResponse } from "../../../models/cartable.model";
import { GetCartables } from "../../../services/cartable.service";
import { setstateCartable } from "../../../redux/activeState/activeStateAction";
import ToolsCmp from "../ToolsCmp";
import TableFindCmp from "./TableFindCmp";
import TableFindReqCmp from "./TableFindReqCmp";

export default function LoanFindReqPage() {
    return (
        <div>
            <TableFindReqCmp />
        </div>
    )
}
